import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnInit } from '@angular/core';

@Component({
  selector: 'file-picker',
  templateUrl: './file-picker.html',
  standalone: false,
})
export class FilePickerComponent implements OnInit {
  @ViewChild('filePicker', { static: true }) filePicker: ElementRef;
  @Output('onFileChange') onFileChange: EventEmitter<any> = new EventEmitter<any>();
  @Input('capture') capture: string;
  @Input('accept') accept: string = 'image/*.jpeg';

  ngOnInit(): void {
    if (this.capture) this.filePicker.nativeElement.setAttribute('capture', this.capture);
  }

  openFileIntent(): void {
    this.filePicker.nativeElement.click();
  }

  uploadImageFromNativeCamera(event: any): void {
    this.onFileChange.emit(event);
  }
}
